$('form.brochure-download-form').on('submit', function (e) {
    e.preventDefault();

    var form = $(this);
    let hubspot_workflow_id = form.find('input[name=hubspot_workflow_id]').val();
    let brochure_file = $('select[name="brochure_file"]',form).val();

    let first_name = form.find('input[name=first_name]').val();
    let last_name = form.find('input[name=last_name]').val();
    let email = form.find('input[name=email]').val();
    let emailpreference = form.find('input[name=emailpreference]').is(':checked');

    let isValid = true;

    // additional validity checks for required fields on contact button submit
    $('input:required', form).each((i, input) => {
        if (input.validity.valid) {
            $(input).removeClass('input-required');
            if ($(input).next().hasClass('error-required')) {
                $(input).next().remove();
            }
        } else {
            isValid = false;
            $(input).addClass('input-required');
            if (!$(input).next().hasClass('error-required')) {
                $('<span class="block error-required">Input required</span>').insertAfter($(input));
            }
        }
    });

    if (isValid) {
        $("body").css("cursor", "progress");
        $('button[type="submit"]',form).addClass('disabled').attr("disabled", true);
        axios({
            method: 'POST',
            url: '/brochure-download',
            data: { brochure_file, hubspot_workflow_id, first_name, last_name, email, emailpreference: emailpreference }
        })
            .then(function (response) {
                form[0].reset();
                if (response.data.brochure_link) {
                    window.open(response.data.brochure_link);
                }
                $("body").css("cursor", "default");
                $('button[type="submit"]',form).removeClass('disabled').attr("disabled", false);
            })
            .catch(function (error) {
            });
    }

});

$("form.brochure-download-form #emailpreference").on('click', function () {
    var isChecked = $(this).is(":checked");
    var $submit = $('form.brochure-download-form button[type="submit"]');
    if (isChecked) { 
        $submit.removeClass('disabled').attr("disabled", false);
    } else {
        $submit.addClass('disabled').attr("disabled", true);
    }
});